module.exports = __webpack_public_path__ + "static/media/pulverizador_leque_2.dee14490.png";